import { render, staticRenderFns } from "./logisticsOrderDetail.vue?vue&type=template&id=74e9f1bd&scoped=true"
import script from "./logisticsOrderDetail.vue?vue&type=script&lang=js"
export * from "./logisticsOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./logisticsOrderDetail.vue?vue&type=style&index=0&id=74e9f1bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e9f1bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e9f1bd')) {
      api.createRecord('74e9f1bd', component.options)
    } else {
      api.reload('74e9f1bd', component.options)
    }
    module.hot.accept("./logisticsOrderDetail.vue?vue&type=template&id=74e9f1bd&scoped=true", function () {
      api.rerender('74e9f1bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/logisticsOrderList/logisticsOrderDetail.vue"
export default component.exports